import React, { Component } from 'react';
import { connect } from 'react-redux';

import {
  nextSeatmap,
  showModal,
  setLoading,
  setCurrentSeatMap,
  updateSelectedSeat,
  setCurrentPassenger,
  confirmBasket,
  setBasketUpdated,
  setShowSeatmapValidateInfant,
  setShowSeatmapValidateGroup,
  setShowOnClosePopUp,
} from '../../redux/actions';
import Button from '../shared/Button';

import { FormattedMessage } from 'react-intl';

import {
  validateInfants,
  validateLargeGroup,
} from '../../utils/validateBasket';

import { missingSeatsForSegment } from '../../utils/onExitModalPopupValidation';
import { isNewSeatmapDesign } from '../../utils/seatmapDesign';

export class NextFlight extends Component {
  constructor(props) {
    super(props);
    this.state = {
      buttonType: null,
    };
  }

  _validateSelections = () => {
    const {
      basket,
      passengers,
      segmentColumns,
      setShowSeatmapValidateInfant,
      setShowSeatmapValidateGroup,
      restrictionMap,
      itinerary,
    } = this.props;

    if (!validateInfants(basket, passengers, segmentColumns)) {
      // invalid seats due to infants
      setShowSeatmapValidateInfant(true);
      return false;
    }

    if (
      !validateLargeGroup(
        basket,
        passengers,
        restrictionMap,
        itinerary.currentSeatmap
      )
    ) {
      // invalid seats due to large group
      setShowSeatmapValidateGroup(true);
      return false;
    }
    return true;
  };

  onNextClick = () => {
    const { updateSelectedSeat, setCurrentPassenger, passengers } = this.props;
    updateSelectedSeat(null);

    if (!this._validateSelections()) {
      return;
    }

    const next = this.getNextAvailable();

    setCurrentPassenger(passengers[0]);
    // if valid seating arrangement with infants, otherwise show error
    this.progressToNextOrFinish(next);
  };

  getNextAvailable = () => {
    const { itinerary } = this.props;
    const { flights = [], currentSeatmap } = itinerary;
    for (let i = 0, foundMatch = false; i < flights.length; i++) {
      const seatmap = flights[i];
      if (foundMatch && seatmap.available) {
        return seatmap;
      } else if (seatmap.segment_id === currentSeatmap) {
        foundMatch = true;
      }
    }
    return null;
  };

  progressToNextOrFinish = (next) => {
    const {
      editMode,
      setShowOnClosePopUp,
      variants,
      basket = {},
      itinerary = {},
      passengers,
    } = this.props;
    const { test_seatmap_on_exit_modal = false } = variants;

    const confirmSelection = () => {
      if (!process.env.STORYBOOK_USED) {
        this.props.setBasketUpdated(true);
        this.props.confirmBasket();
      }
    };

    if (
      test_seatmap_on_exit_modal &&
      missingSeatsForSegment(basket, passengers, itinerary.currentSeatmap)
    ) {
      const nextFunction = next
        ? () => this.props.nextSeatmap(next.segment_id)
        : confirmSelection;
      setShowOnClosePopUp({
        show: true,
        trigger: 'ON_NEXT',
        next_function: nextFunction,
      });
      return;
    }
    if (!next || editMode) {
      confirmSelection();
      return;
    }
    return this.props.nextSeatmap(next.segment_id);
  };

  render() {
    const { variants } = this.props;
    const { test_confirm_on_click = false } = variants;

    const chooseButton = () => {
      const nextSeatMap = this.getNextAvailable();
      if (!nextSeatMap || this.props.editMode) {
        return (
          <FormattedMessage id="select_seats" defaultMessage="Select seats" />
        );
      } else {
        return (
          <FormattedMessage id="next_flight" defaultMessage="Next flight" />
        );
      }
    };

    const showButton =
      !test_confirm_on_click || chooseButton().props.id !== 'select_seats';

    const isDisabled =
      this.props.basketChanging ||
      this.props.showSeatmapValidateInfantPopup ||
      this.props.showSeatmapValidateGroupPopup ||
      this.props.showOnClosePopUp.show;

    const useNewDesign = isNewSeatmapDesign(this.props.variants);

    return (
      showButton && (
        <div className="gr-flex gr-flex-row gr-gap-3 gr-w-full gr-justify-end">
          <div
            className={
              this.props.className || 'gr-w-40 sm:gr-w-56 gordian-button-width'
            }
          >
            {!useNewDesign ? (
              <Button
                primary
                id="next-button"
                hovergrBg="blue-primary"
                hoverTextColor="gr-text-white"
                handleClick={() => this.onNextClick()}
                disabled={isDisabled}
                className="gr-flex gr-flex-row gr-justify-around"
              >
                <span className="gr-m-auto">{chooseButton()}</span>
              </Button>
            ) : (
              <button
                id="next-button"
                onClick={(e) => {
                  e.preventDefault();
                  this.onNextClick();
                }}
                disabled={isDisabled}
                className={`gr-w-full gr-h-12 gr-rounded-full gr-font-semibold gr-text-sm gr-transition-colors gr-duration-150 gr-border-0 ${
                  isDisabled
                    ? 'gr-bg-gray-300 gr-text-gray-500 gr-cursor-not-allowed'
                    : 'gr-cursor-pointer gordian-button-primary-v3'
                }`}
              >
                {chooseButton()}
              </button>
            )}
          </div>
        </div>
      )
    );
  }
}

const mapStateToProps = (state) => ({
  basket: state.basket,
  itinerary: state.itinerary,
  passengers: state.passengers.listOfPassenger,
  editMode: state.session.editMode,
  variants: state.session.variants,
  basketChanging: state.session.basketChanging,
  segmentColumns: state.session.segmentColumns,
  showSeatmapValidateInfantPopup: state.session.showSeatmapValidateInfantPopup,
  showSeatmapValidateGroupPopup: state.session.showSeatmapValidateGroupPopup,
  restrictionMap: state.itinerary.restrictionMap,
  showOnClosePopUp: state.session.showOnClosePopUp,
});

const mapDispatchToProps = {
  setCurrentSeatMap,
  setLoading,
  nextSeatmap,
  updateSelectedSeat,
  setCurrentPassenger,
  showModal,
  confirmBasket,
  setBasketUpdated,
  setShowSeatmapValidateInfant,
  setShowSeatmapValidateGroup,
  setShowOnClosePopUp,
};

export default connect(mapStateToProps, mapDispatchToProps)(NextFlight);
